import type { PublicSlotKey } from '#packages/apilib';
import type { PasteClipboardDataToStageApi } from './pasteClipboardDataToStageApi';

export const PasteClipboardDataToStageApiKey: PublicSlotKey<PasteClipboardDataToStageApi> =
  {
    name: 'PasteClipboardDataToStageApi',
    public: true,
  };
